import { Flex, HStack, IconButton, Text } from '@chakra-ui/react'
import {
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverRoot,
  PopoverTrigger,
} from '@/components/ui/popover'
import { InfoIcon } from '@/app/[locale]/_assets/icon-components'

export default function Popover({
  data,
}: {
  data: { value: number; label: string }[]
}) {
  if (data.every((nutrient) => !nutrient.value)) {
    return null
  }

  return (
    <PopoverRoot >
      <PopoverTrigger asChild>
        <IconButton size="sm" variant="ghost" rounded="full" mr={2}>
          <InfoIcon />
        </IconButton>
      </PopoverTrigger>
      <PopoverContent bg='background.card' color='text' className='ingredients__popover'>
        <PopoverArrow />
        <PopoverBody>
          <HStack gap={6} mt={4}>
            {data
              .filter((nutrient) => nutrient.value && nutrient.value > 0)
              .map((nutrient, index) => (
                <Flex key={index} fontSize="sm" flexDir="column" gap={0}>
                  <Text>{nutrient.value}</Text>
                  <Text>{nutrient.label}</Text>
                </Flex>
              ))}
          </HStack>
        </PopoverBody>
      </PopoverContent>
    </PopoverRoot>
  )
}
